import { IcdCode, useGetIcdCodesQuery } from '../../types';

export interface UseIcdCodeQueriesResult {
  rows: IcdCode[];
  loading: boolean;
  hasError: boolean;
}

const EMPTY_ROWS: IcdCode[] = [];

export const useIcdCodeQueries = (): UseIcdCodeQueriesResult => {
  const { data, loading, error } = useGetIcdCodesQuery();

  return {
    rows: data?.getIcdCodes?.items ?? EMPTY_ROWS,
    loading,
    hasError: !!error,
  };
};
